module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/181b5fac890880865e9131cde17e3d49.png";